import React, { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { personalInfo } from "../data/mock";

const Header = ({ activeSection }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = [
    { name: "About", href: "#about", id: "about", num: "01" },
    { name: "Work", href: "#experience", id: "experience", num: "02" },
    { name: "Stack", href: "#skills", id: "skills", num: "03" },
    { name: "Projects", href: "#projects", id: "projects", num: "04" }
  ];

  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-bg/75 backdrop-blur-lg border-b border-rule"
          : "bg-transparent border-b border-transparent"
        }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <button
            onClick={() => go("#home")}
            className="font-mono text-sm text-ink hover:text-accent transition-colors flex items-center gap-1.5"
            aria-label="Home"
          >
            <span className="text-accent">~/</span>
            <span className="lowercase">{personalInfo.username}</span>
          </button>

          <nav className="hidden md:flex items-center gap-1">
            {nav.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.href)}
                className={`group px-3 py-2 text-sm transition-colors ${activeSection === item.id ? "text-ink" : "text-ink-2 hover:text-ink"
                  }`}
              >
                <span className="font-mono text-accent text-xs mr-1.5">{item.num}.</span>
                {item.name}
              </button>
            ))}
            <a
              href={`mailto:${personalInfo.email}`}
              className="ml-4 group flex items-center gap-1.5 px-4 py-1.5 border border-accent/40 text-accent text-sm rounded-full hover:bg-accent-dim hover:border-accent transition-all"
            >
              <span className="font-mono text-xs">get in touch</span>
              <ArrowUpRight className="w-3.5 h-3.5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
            </a>
          </nav>

          <button
            className="md:hidden text-ink hover:text-accent transition-colors"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <nav className="md:hidden pb-5 pt-2 border-t border-rule flex flex-col gap-1">
            {nav.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.href)}
                className={`text-left px-2 py-2.5 text-sm transition-colors ${activeSection === item.id ? "text-accent" : "text-ink-2 hover:text-ink"
                  }`}
              >
                <span className="font-mono text-accent text-xs mr-2">{item.num}.</span>
                {item.name}
              </button>
            ))}
            <a
              href={`mailto:${personalInfo.email}`}
              className="mt-2 inline-flex items-center gap-1.5 px-4 py-2 border border-accent/40 text-accent text-sm rounded-full w-fit"
            >
              <span className="font-mono text-xs">get in touch</span>
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2} />
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
